import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import mitt from 'mitt';
const emitter = mitt();
const MittContext = React.createContext({ emitter });
export const MittProvider = ({ children }) => {
    return _jsx(MittContext.Provider, Object.assign({ value: { emitter } }, { children: children }), void 0);
};
export const useMitt = () => useContext(MittContext);
